import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import SciChat from './components/SciChat';
import Header from './components/Header';
import LoginScreen from './screens/LoginScreen';
import InitalInfor from './screens/InitalInfor';
import { AppProvider } from './context/AppContext';
import UserChat from './components/UserChat';

function App() {

  
  return (
    <AppProvider>
      <Router>
        <Header />
        <div className='mt-14'>
          <Routes>
            <Route path="/" element={<InitalInfor />} />
            <Route path="/login" element={<LoginScreen />} />
            <Route path="/chat" element={<SciChat />} />
            <Route path="/user-chat" element={<UserChat />} />
          </Routes>
        </div>
      </Router>
    </AppProvider>
  );
}

export default App;
